import React from "react";
import { LockClosedIcon } from "@heroicons/react/24/solid";

const STYLES = {
  pro: "bg-indigo-500/15 text-indigo-500",
  plus: "bg-purple-500/15 text-purple-500",
  advisor: "bg-amber-500/15 text-amber-500",
};

// Small "PRO" / "PLUS" lock pill for menu items and toggles.
const TierBadge = ({ tier = "pro", className = "" }) => (
  <span
    className={`inline-flex items-center gap-1 text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-full ${
      STYLES[tier] || STYLES.pro
    } ${className}`}
  >
    <LockClosedIcon className="w-2.5 h-2.5" />
    {tier}
  </span>
);

export default TierBadge;
